<ng-template #discoveredScannableDocuments>
  @if (useDsTable) {
    <div class="scannable-documents-table">
      <ds-table-component
        [columns]="dsTableConfig.columns"
        [data]="(dsTableData$ | async) ?? []"
        [caption]="dsTableConfig.tableCaption"
        [emptyState]="dsTableConfig.emptyState"
        [withPagination]="true"
      ></ds-table-component>
      <ds-pagination-v2
        [ariaLabel]="dsTableConfig.tableCaption"
        [page]="(page$ | async) ?? 1"
        [pageSize]="(pageSize$ | async) ?? pageSizes[pageSizes.length - 1]"
        [pageSizeOptions]="pageSizes"
        [collectionSize]="(totalRows$ | async) ?? 0"
        [paginationForTable]="true"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      ></ds-pagination-v2>
    </div>
  } @else {
    <div
      class="pagination-entries"
      [ngClass]="{ 'justify-content-between': isMonitoringScan, 'justify-content-end pt-3': !isMonitoringScan }"
    >
      @if (isMonitoringScan) {
        <span data-e2e-id="discovered-items-number" class="text-black fw-normal" [ngPlural]="totalRows$ | async">
          <ng-template ngPluralCase="=1">{{ 'one_item' | translate }}</ng-template>
          <ng-template ngPluralCase="other">{{ 'number_of_items' | translate: (totalRows$ | async) }}</ng-template>
        </span>
      }
      <app-responsive-pagination
        [page]="page$ | async"
        [pageSize]="pageSize$ | async"
        [collectionSize]="totalRows$ | async"
        [entryLimits]="pageSizes"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      ></app-responsive-pagination>
    </div>

    <div class="mb-3 scannable-documents-table">
      <app-ngb-table
        [config]="tableConfig"
        [sortingOrder]="sortOrder$ | async"
        [data]="tableData$ | async"
        (onSort)="onSort($event)"
        [allSelected]="allPageSelected$ | async"
      ></app-ngb-table>
    </div>

    <div class="pagination-entries mb-0 justify-content-end">
      <app-responsive-pagination
        idSuffix="Bottom"
        [page]="page$ | async"
        [pageSize]="pageSize$ | async"
        [collectionSize]="totalRows$ | async"
        [entryLimits]="pageSizes"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      ></app-responsive-pagination>
    </div>
  }
</ng-template>

@if (shouldShowComponent()) {
  <div class="card">
    <div class="card-header p-4">
      <h3>{{ 'scannable_documents_discovered' | translate }}</h3>
    </div>
    <div class="card-body discovered-scannable-documents">
      <ng-template [ngTemplateOutlet]="discoveredScannableDocuments"></ng-template>
    </div>
  </div>
}

@if (isMonitoringScan) {
  <div class="mt-4">
    <h2>{{ 'pdfs_discovered' | translate }}</h2>
    <ng-template [ngTemplateOutlet]="discoveredScannableDocuments"></ng-template>
  </div>
}
